import { Injectable } from "@angular/core";
import { ItemBusquedaModel } from '../utilidades.modelos.index';
import { UtilidadesService } from '../utilidades.servicios.index';
import { Observable } from "rxjs";

@Injectable()
export class LocalidadesService {

	constructor(
		private Utilidades: UtilidadesService
	) { }

	public Lista(delPais: boolean = false): Observable<ItemBusquedaModel[]> {
		return this.Utilidades.Get("Externos/Localidades/" + delPais);
	}

	public Obtener(id: string, delPais: boolean = false): Observable<ItemBusquedaModel> {
		return this.Utilidades.Get("Externos/Localidades/Obtener/" + id + "/" + delPais);
	}

	public ObtenerConCalle(idLocalidad: string, idCalle: string, delPais: boolean = false): Observable<ItemBusquedaModel> {
		return this.Utilidades.Get("Externos/Localidades/Obtener/" + idLocalidad + "/" + idCalle + "/" + delPais);
	}
}